@import './fonts';

* {
  box-sizing: border-box;
  font-family: var(--font-family);
}

h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
}

:host(.font-family-secondary) {
  * {
    font-family: var(--font-family-secondary);
  }
}

:host {
  box-sizing: border-box;
  font-family: var(--font-family);
  display: block;
  width: 100%;
  height: 100%;
}

.wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  position: relative;
}

.page__header {
  background: var(--white-layout-301-level-0-elevation);
  border-color: var(--chart-101-pressed-dividers) !important;
}

.gz-info-message {
  height: 100%;
  .message-container {
    color: var(--chart-300-icon-buttons);
    display: flex;
    height: 100%;
    align-items: center;

    .message {
      margin-left: calc(2 * var(--spacer));
      max-width: 200px;
    }
  }
}

.list-unstyled {
  list-style: none;
  margin: 0;
  padding: 0;
}

/* BUTTONS */

.icon-button {
  border: 0;
  cursor: pointer;

  &:active,
  &:focus {
    outline: none;
    border: none;
  }

  &.accent {
    color: var(--blue-layout-403-primary);
    background-color: transparent;

    &:hover {
      color: var(--blue-layout-301-active);
    }

    &:active {
      color: var(--blue-layout-501-focus);
    }
  }
}

.button {
  border: 0;
  cursor: pointer;
  font-size: var(--body-size-medium);
  line-height: 1;
  text-transform: uppercase;
  font-weight: bold;
  border-radius: var(--widget-border-radius);
  text-align: center;
  padding: var(--spacer) calc(2 * var(--spacer));
  transition: all 0.3s ease;

  &:active,
  &:focus {
    outline: none;
    border: none;
  }

  &.accent {
    background-color: var(--blue-layout-403-primary);
    color: var(--white-layout-300-primary) !important;

    &:hover {
      background-color: var(--blue-layout-301-active);
    }
  }
}

.has-pointer {
  cursor: pointer;
}

.info-text {
  color: var(--body-text-arrows-400);
  line-height: 18px;
  max-width: 870px;
}

*::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

* {
  scrollbar-width: thin;
  scrollbar-color: var(--chart-104-pressed) var(--white-layout-302-level-1-elevation);
}

*::-webkit-scrollbar-track {
  background: var(--white-layout-302-level-1-elevation);
}
*::-webkit-scrollbar-thumb {
  background-color: var(--chart-104-pressed);
  border-radius: 6px;
}

.hidden {
  display: none !important;
}

.visibility-hidden {
  visibility: hidden;
  pointer-events: none;
}

/* SIZE HELPERS */

.w-full {
  width: 100%;
}

.h-full {
  height: 100%;
}

// delete this class and use gz-card component instead of this css class!
.gz-card {
  background-color: var(--white-layout-302-level-1-elevation);
  color: var(--body-text-arrows-400);
  padding: calc(2 * var(--spacer));
  margin-bottom: calc(2 * var(--spacer));
}

.has-bullet {
  position: relative;
  font-family: inherit;
  transform: translateY(1px);

  &:before {
    content: '';
    display: inline-block;
    width: 10px;
    height: 10px;
    min-width: 10px;
    border-radius: 50%;
    margin-right: 6px;
    background-color: var(--red-alert-500-severe);
  }

  &.bullet-neutral {
    &:before {
      background-color: var(--grey-layout-202-disabled-icons);
    }
  }

  &.bullet-success {
    &:before {
      background-color: var(--green-layout-100-primary-green);
    }
  }

  &.bullet-warning {
    &:before {
      background-color: var(--orange-layout-050-warning);
    }
  }

  &.bullet-danger {
    &:before {
      background-color: var(--red-chart-600);
    }
  }

  &.bullet-darkred {
    &:before {
      background-color: var(--red-alert-chart-700-critical);
    }
  }

  &.bullet-orange {
    &:before {
      background-color: var(--orange-alert-chart-100);
    }
  }

  &.bullet-yellow {
    &:before {
      background-color: var(--yellow-alert-050);
    }
  }

  &.bullet-grey {
    &:before {
      background-color: var(--chart-300-icon-buttons);
    }
  }

  &.bullet-transparent {
    &:before {
      background-color: var(--white-layout-300);
      border: 1px solid;
      border-color: var(--grey-layout-200-30-opacity);
      box-sizing: border-box;
    }
  }
}

.is-disabled {
  pointer-events: none !important;
  opacity: 0.8 !important;
}

[disabled] {
  pointer-events: none !important;
}

.disabled-field-error {
  pointer-events: none;
}

@media (prefers-color-scheme: dark) {
  /* Dark mode styles go here */
}

.w-auto {
  width: auto;
}

.helper-text {
  padding-left: calc(var(--spacer) * 3.25);
  color: var(--chart-300-icon-buttons);
  line-height: 18px;
}
